module.exports = __webpack_public_path__ + "static/00003.fef85566.jpg";